import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import KallistoLogo from './KallistoLogo';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gray-900/80 backdrop-blur-md border-b border-gray-700/50 text-white h-16">
      <nav className="max-w-7xl mx-auto relative flex items-center justify-between px-6 h-full">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-green-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">K</span>
          </div>
          <span className="text-white font-bold text-xl">Kallisto</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/" className="text-white/80 hover:text-white transition-colors">
            Home
          </Link>
          <Link to="/services" className="text-white/80 hover:text-white transition-colors">
            Services
          </Link>
          <Link to="/cases" className="text-white/80 hover:text-white transition-colors">
            Portfolio
          </Link>
          <Link to="/about" className="text-white/80 hover:text-white transition-colors">
            About
          </Link>
          <Link to="/contact" className="text-white/80 hover:text-white transition-colors">
            Contact
          </Link>
        </div>

 {/* CTA Button */}
 <div className="hidden md:flex items-center">
   <a
     href="https://calendly.com/sergii-kozyrev-kallisto/30min"
     target="_blank"
     rel="noopener noreferrer"
     className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
   >
     Book a call
   </a>
 </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-white focus:outline-none"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {menuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-gray-900/95 backdrop-blur-md border-t border-gray-700/50 px-6 py-4">
          <div className="flex flex-col gap-4">
            <Link 
              to="/" 
              onClick={() => setMenuOpen(false)} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              Home
            </Link>
            <Link 
              to="/services" 
              onClick={() => setMenuOpen(false)} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              Services
            </Link>
            <Link 
              to="/cases" 
              onClick={() => setMenuOpen(false)} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              Portfolio
            </Link>
            <Link 
              to="/about" 
              onClick={() => setMenuOpen(false)} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              About
            </Link>
            <Link 
              to="/contact" 
              onClick={() => setMenuOpen(false)} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              Contact
            </Link>
            <div className="pt-4 border-t border-gray-700">
              <a
                href="https://calendly.com/sergii-kozyrev-kallisto/30min"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-gray-900 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-100 transition-colors inline-block"
                onClick={() => setMenuOpen(false)}
              >
                Get started
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
